import * as React from 'react';
import Comment from '../../../models/comment';
import * as styles from './modal.module.scss';

interface Props {
  comment: Comment;
}

const CommentDisplay = ({ comment }: Props) => {
  return (
    <div className={styles.commentWrapper}>
      <span className={styles.author}>{comment.author}</span>
      <div className={styles.commentDetails}>
        <span>{comment.createdTimeFriendly}</span>
        <span dangerouslySetInnerHTML={{ __html: comment.body }} />
      </div>
    </div>
  );
};

export default CommentDisplay;
